import * as React from "react";
import { cn } from "../../lib/utils";
import { FAQ_SECTION_STYLES } from "./constants";
import type { FaqSectionProps } from "./types";

export const FaqSection = React.forwardRef<HTMLElement, FaqSectionProps>(
  ({ className, title, description, items, ...props }, ref) => {
    return (
      <section
        ref={ref}
        className={cn(FAQ_SECTION_STYLES.root, className)}
        {...props}
      >
        <h2 className={FAQ_SECTION_STYLES.title}>{title}</h2>
        {description && (
          <p className={FAQ_SECTION_STYLES.description}>{description}</p>
        )}

        <div className={FAQ_SECTION_STYLES.list}>
          {items.map((item) => (
            <details
              key={item.id}
              className={FAQ_SECTION_STYLES.item}
              open={item.defaultOpen}
            >
              <summary className={FAQ_SECTION_STYLES.summary}>
                <span>{item.question}</span>
                <span aria-hidden="true" className={FAQ_SECTION_STYLES.chevron}>
                  +
                </span>
              </summary>
              <div className={FAQ_SECTION_STYLES.answer}>{item.answer}</div>
            </details>
          ))}
        </div>
      </section>
    );
  }
);

FaqSection.displayName = "FaqSection";
